// #region Imports
// Librerías externas
import React, { useEffect, useMemo, useState } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import classnames from "classnames"
import { Link } from "react-router-dom"
import InputMask from "react-input-mask"
import { ToastContainer, toast } from "react-toastify"
import Flatpickr from "react-flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import FormikInput from "./Formik/FormikInput"
import FormikInputRFC from "./Formik/FormikInputRFC"
import FormikAsyncSelect from "./Formik/FormikAsyncSelect"
import FormikSelect from "./Formik/FormikSelect"
import PropTypes from "prop-types"
import TableContainer from "./TableContainer"
import { GetOptionsRegimenesFiscalesFn } from "../../constants/regimenesfiscales"
import { GetOptionsEstadosFederativosFn } from "../../constants/estadosFederativos"
import "flatpickr/dist/themes/material_blue.css"
import "react-toastify/dist/ReactToastify.css"
import "react-datepicker/dist/react-datepicker.css"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

//redux
import { useDispatch } from "react-redux"

// Componentes internos
import Breadcrumbs from "./Breadcrumb"
import { AltaContribuyenteSchema } from "../../utils/validationSchemas"

// Reactstrap
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  UncontrolledAlert,
  UncontrolledTooltip,
} from "reactstrap"

// Selectors
import {
  useContribuyentesMensajeExito,
  useContribuyentesError,
} from "store/selectors"
// #endregion

// #region actions
import {
  postContribuyentesCreate,
  unsetContribuyentesError,
  unsetContribuyentesMensajeExito,
} from "../../store/actions"
// #endregion

const hoy = new Date()
const primerDiaMes = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  1
)

const ContribuyentesInsert = () => {
  //
  // Options

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // Const

  // #region Internal States
  const [optionsRegimenesFiscales, setOptionsRegimenesFiscales] = useState([])
  // #endregion

  // Estados para manejar tabs y pasos completados
  const mensajeExito = useContribuyentesMensajeExito()
  const mensajeError = useContribuyentesError()
  // #endregion

  // Funciones para manejar cambios en mayúsculas y minúsculas
  const handleUpperCaseChange = event => {
    const { name, value } = event.target
    formik.setFieldValue(name, value.toUpperCase())
  }

  const handleNumberChange = event => {
    const { name, value } = event.target

    // Reemplaza cualquier carácter que no sea un dígito (0-9) por una cadena vacía
    const numericValue = value.replace(/\D/g, "").slice(0, 5)

    formik.setFieldValue(name, numericValue)
  }

  const initialValues = {
    RFC: "",
    Razon_Social: "",
    Regimen_Fiscal: "",
    Codigo_Postal: "",
    id_Estado: -1,
  }

  const onSubmit = values => {
    dispatch(
      postContribuyentesCreate({
        nombreSolicitud: "create",
        Codigo_Postal: values.Codigo_Postal,
        RFC: values.RFC,
        Razon_Social: values.Razon_Social,
        Regimen_Fiscal: values.Regimen_Fiscal,
        id_Estado: values.id_Estado,
      })
    )
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: AltaContribuyenteSchema,
    onSubmit: onSubmit,
  })
  // #endregion

  //#region Formik form
  // Definición de initialValues y validationSchema
  const rfc = formik.values["RFC"]

  // #region UseEffects
  useEffect(() => {
    const RFC = formik.values["RFC"]
    if (RFC.length > 11) {
      setOptionsRegimenesFiscales(GetOptionsRegimenesFiscalesFn(rfc, true))
    }
  }, [rfc])

  useEffect(() => {
    if (mensajeExito) {
      toast.success(mensajeExito, {
        autoClose: 2000,
      })
      dispatch(unsetContribuyentesMensajeExito())

      formik.resetForm()
    }
  }, [mensajeExito, dispatch, formik])

  useEffect(() => {
    if (mensajeError) {
      toast.error(mensajeError, {
        autoClose: 2000,
      })
      dispatch(unsetContribuyentesError())
    }
  }, [mensajeError, dispatch])

  // #endregion

  // #region Functions

  // #endregion
  return (
    <React.Fragment>
      <ToastContainer />
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <Col md={6}>
            <div className="mb-3">
              <FormikInputRFC
                label="* RFC"
                name="RFC"
                placeholder="RFC"
                formik={formik}
                onChange={handleUpperCaseChange}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-3">
              <FormikInput
                label="* Razón Social"
                name="Razon_Social"
                placeholder="Razón Social"
                formik={formik}
                onChange={handleUpperCaseChange}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="mb-3">
              <FormikSelect
                label="* Régimen Fiscal"
                name="Regimen_Fiscal"
                placeholder="Régimen Fiscal"
                options={optionsRegimenesFiscales || []}
                formik={formik}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-3">
              <FormikInput
                label="* Código Postal"
                name="Codigo_Postal"
                placeholder="Codigo_Postal"
                formik={formik}
                onChange={handleNumberChange}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="mb-3">
              <FormikSelect
                label="* Estado Federativo"
                name="id_Estado"
                placeholder="Estado Federativo"
                options={GetOptionsEstadosFederativosFn(false) || []}
                formik={formik}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <div className="d-flex justify-content-end mt-2">
            <Button
              color="primary"
              type="submit"
              className="btn waves-effect waves-light me-1 w-lg"
              disabled={false}
            >
              {" "}
              Agregar
            </Button>
            <Button
              color="danger"
              className="btn waves-effect waves-light me-1 w-lg"
              disabled={false}
              onClick={() => {
                console.log("Errors: ", formik.errors)
              }}
            >
              {" "}
              check form
            </Button>
          </div>
        </Row>
      </Form>
    </React.Fragment>
  )
}

export default ContribuyentesInsert
